import { render, staticRenderFns } from "./BrandLogosWidgetItem.vue?vue&type=template&id=67a626f0&scoped=true"
import script from "./BrandLogosWidgetItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandLogosWidgetItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BrandLogosWidgetItem.vue?vue&type=style&index=0&id=67a626f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a626f0",
  null
  
)

export default component.exports